import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import { fetchReciters, createReciter, deleteReciter } from "../../lib/api";

export default function AdminReciters() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", bio: "", avatar: "" });
  const reload = () => fetchReciters().then(setItems).catch(() => {});
  useEffect(() => { reload(); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) return toast.error("Name required");
    await createReciter(form);
    toast.success("Reciter added");
    setForm({ name: "", bio: "", avatar: "" });
    reload();
  };

  return (
    <div data-testid="admin-reciters-page" className="space-y-10">
      <div>
        <div className="overline text-[#B79C7B]">People</div>
        <h1 className="font-serif text-4xl text-ivory mt-2">Reciters & Zakireen</h1>
      </div>
      <section className="border border-[#2A2A2D] bg-[#121214] p-8">
        <form onSubmit={onSubmit} className="grid md:grid-cols-3 gap-4">
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reciter-name" />
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Avatar URL" value={form.avatar} onChange={(e) => setForm({ ...form, avatar: e.target.value })} data-testid="reciter-avatar" />
          <button type="submit" className="h-11 bg-[#8A2E2E] hover:bg-[#A33B3B] text-sm tracking-widest flex items-center justify-center gap-2" data-testid="add-reciter-button"><Plus size={16} /> ADD</button>
          <textarea className="md:col-span-3 min-h-[80px] bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 py-3 text-ivory" placeholder="Bio" value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} data-testid="reciter-bio" />
        </form>
      </section>
      <section className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((r) => (
          <div key={r.id} className="border border-[#2A2A2D] bg-[#121214] p-5 flex items-center gap-4" data-testid={`reciter-card-${r.id}`}>
            <div className="w-14 h-14 bg-[#1A1A1D] overflow-hidden border border-[#2A2A2D] shrink-0">
              {r.avatar && <img src={r.avatar} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-ivory truncate">{r.name}</div>
              <div className="text-xs text-[#71717A] truncate">{r.bio}</div>
            </div>
            <button onClick={async () => { await deleteReciter(r.id); reload(); }} className="text-[#71717A] hover:text-[#FF3B30]" data-testid={`delete-reciter-${r.id}`}><Trash size={14} /></button>
          </div>
        ))}
      </section>
    </div>
  );
}
